import React, { type FC } from "react";
import { useCarConfigSelector } from "../../../redux/store";
import styles from "../common/navigation/Navigation.module.scss";
import { trackHighlightsHeaderMenuClick } from "../../../utils/tracking";
import Button from "../../../../shared-components/css-modules/toyota/atoms/Button";
import { useCarouselContext } from "../../../../shared-components/css-modules/toyota/vendor/carousel/CarouselContext";

const HighlightsNavigationButton: FC<{ section: string; label: string; name: string; index: number }> = ({
    section,
    name,
    label,
    index,
}) => {
    const sectionIsActive = useCarConfigSelector((state) => state.carConfigNavigation.activeSection === section);
    const { carouselProperties } = useCarouselContext();

    if (!carouselProperties) return null;

    const { addNode } = carouselProperties;

    return (
        <li ref={(node) => addNode(node, index)}>
            <Button
                href={`#${section}`}
                id={`${section}-button`}
                variant="clean"
                className={`${styles["nav-link"]} ${sectionIsActive ? ` ${styles.active}` : ""}`}
                onClick={() => {
                    // This prevents the history being pushed with each section change. This way the browser back button goes to the previous page.
                    window.history.replaceState(window.history.state, "", `#${section}`);

                    trackHighlightsHeaderMenuClick(name);
                }}
                aria-current={sectionIsActive ? "true" : undefined}
            >
                <span>{label}</span>
            </Button>
        </li>
    );
};

export default HighlightsNavigationButton;
